import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { ISichtbarkeiten } from '../_interfaces/sichtbarkeiten';
import { IChoiceList } from '../_interfaces/_choice-list';
import * as moment from 'moment'; // DateTimeOffset-Fix
import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';
import { TokenizeResult } from '@angular/compiler/src/ml_parser/lexer';

@Injectable()
export class SichtbarkeitenService extends CRUDBasicService {
  
  private sichtbarkeiten: ISichtbarkeiten[] = []; // Tabelle zum Programmstart laden


  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'id', type: 'int'},
    {name: 'name', type: 'string'},
    {name: 'istAusgeblendet', type: 'bool'},
    {name: 'createdBy', type: 'string'},
    {name: 'created', type: 'DateTimeOffset'},
    {name: 'modifiedBy', type: 'string'},
    {name: 'modified', type: 'DateTimeOffset'},
    {name: 'rowVersion', type: 'byte[]'},
  ];
    
  getSichtbarkeiten(): Observable<ISichtbarkeiten[]> {
    return this.httpClient.get<ISichtbarkeiten[]>(
      this.apiBaseUrl + 'sichtbarkeiten',
      { headers: httpOptions, withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );
  }

  loadSichtbarkeiten(): Promise<void> {
    return this.getSichtbarkeiten().toPromise()
      .then(data => {
        this.sichtbarkeiten = data; // Array füllen
      })
      .catch(err => {
        console.error('Fehler beim Laden der Sichtbarkeiten', err);
      });
  }

getSichtbarkeitByName(name: string):boolean {
  
  const eintrag = this.sichtbarkeiten.find(x => x.name === name);
  
  //Wenn kein Tabelleneintrag gefunden wird -> true im ngif -> sichtbar
  if (!eintrag){
    return true; //Standard sichtbar
  }

  //Wenn ein Eintrag gefunden wird und 
  //istAusgeblendet = 0 -> wird negiert zu true also im ngif sichtbar
  //istAusgeblendet = 1 -> wird negiert zu false also im ngif unsichtbar
  else {
    return !eintrag.istAusgeblendet;
  }

}


  // initializeSichtbarkeiten(): ISichtbarkeiten {
  //   return {
  //     id: 0,
  //     name: '',
  //     istAusgeblendet: false,
  //     createdBy: '',
  //     created: '',
  //     modifiedBy: '',
  //     modified: '',
  //     rowVersion: '',
  //   };
  // }


}
